export enum FileEditorClientEvent {
  change = 'change'
}
